<script setup lang="ts">
const { t, tm, rt } = useI18n()

type Item = { icon: string; title: string; text: string }
const items = computed(() =>
  (tm('security.items') as any[]).map((it) => ({
    icon:  rt(it.icon),
    title: rt(it.title),
    text:  rt(it.text),
  })) as Item[],
)
</script>

<template>
  <section id="security" class="rod-section relative overflow-hidden">
    <!-- Subtle vault-ish backdrop: soft cyan + green wash to echo the app palette -->
    <div class="absolute inset-0 pointer-events-none" style="background:
      radial-gradient(45% 60% at 18% 30%, rgba(20,197,219,0.08), transparent 70%),
      radial-gradient(40% 50% at 82% 65%, rgba(31,215,154,0.07), transparent 70%);" />

    <div class="rod-container relative">
      <div class="text-center max-w-3xl mx-auto mb-14" data-reveal>
        <div class="rod-eyebrow mb-5"
             style="background: rgba(20,197,219,0.10); border-color: rgba(20,197,219,0.30); color: #6FE3F1;">
          🛡 {{ t('security.eyebrow') }}
        </div>
        <h2 class="rod-h2 mb-5">{{ t('security.title') }}</h2>
        <p class="text-lg text-[var(--color-text-muted)] leading-relaxed">{{ t('security.lead') }}</p>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        <div
          v-for="(item, i) in items"
          :key="i"
          class="rod-card relative flex flex-col gap-4"
          data-reveal
        >
          <!-- Glyph -->
          <div class="flex items-center gap-3">
            <div class="grid place-items-center w-12 h-12 rounded-2xl flex-shrink-0"
                 style="background: linear-gradient(140deg, rgba(20,197,219,0.18) 0%, rgba(31,215,154,0.10) 100%);
                        border: 1px solid rgba(20,197,219,0.25);
                        font-size: 22px;">
              {{ item.icon }}
            </div>
            <h3 class="rod-h3 leading-tight" style="font-size: 1.15rem;">{{ item.title }}</h3>
          </div>

          <p class="text-[var(--color-text-muted)] leading-relaxed text-[0.95rem]">
            {{ item.text }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
